import React, { useState } from "react";
import { getImgPath } from "../common/helper";
import AboutSutp from "./AboutSutp";
import Partners from "./Partners";
import Itsmc from "./Itsmc";
import BidSection from "./BidSection";
import Suggestions from "./Suggestions";

import { t, HEADING1,PARTNERS,BID_SEC_HEADING,SUGGESTIONS } from "../../translations/AboutUs/SutpIts";

function SutpIts() {
  const [currentTab, setCurrentTab] = useState("SUTP");

  return (
    <div className="body-content">
      <div className="letters-color-section">
        <div className="main_header">{t(HEADING1)}</div>
        <div>
          <img src={getImgPath("/img/aboutus/mitra_1.png")} alt="mitra_1" />
        </div>
        <div className="bottom-highlight">
          <span
            className={`${currentTab == "SUTP" ? "border-highlight" : ""}`}
            onClick={() => setCurrentTab("SUTP")}
          >
            SUTP
          </span>
          <span
            className={`${currentTab == "Partners" ? "border-highlight" : ""}`}
            onClick={() => setCurrentTab("Partners")}
          >
            {t(PARTNERS)}
          </span>
          <span
            className={`${currentTab == "ITSMC" ? "border-highlight" : ""}`}
            onClick={() => setCurrentTab("ITSMC")}
          >
            ITSMC
          </span>
          <span
            className={`${
              currentTab == "BidSection" ? "border-highlight" : ""
            }`}
            onClick={() => setCurrentTab("BidSection")}
          >
            {t(BID_SEC_HEADING)}
          </span>
          <span
            className={`${
              currentTab == "Suggestions" ? "border-highlight" : ""
            }`}
            onClick={() => setCurrentTab("Suggestions")}
          >
            {t(SUGGESTIONS)}
          </span>
        </div>
        {currentTab == "SUTP" && <AboutSutp />}
        {currentTab == "Partners" && <Partners />}
        {currentTab == "ITSMC" && <Itsmc />}
        {currentTab == "BidSection" && <BidSection />}
        {currentTab == "Suggestions" && <Suggestions />}
      </div>
    </div>
  );
}

export default SutpIts;
